import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Layout } from '@/components/Layout';

export function LoginPage() {
  const { currentUser, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (currentUser) {
    return <Navigate to="/" />;
  }

  const handleGoogleAuth = async () => {
    setError('');
    setLoading(true);
    try {
      await signInWithGoogle();
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Google authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div style={{ maxWidth: '440px', margin: '0 auto', paddingTop: '24px' }}>
        <div className="terminal-card">
          <div className="card-header">
            <span className="card-title">Sign In / Create Account</span>
          </div>
          <div className="card-body">
            {error && (
              <div className="terminal-alert error">Error: {error}</div>
            )}

            <p style={{ fontSize: '13px', color: 'var(--text-2)', lineHeight: 1.6, margin: 0 }}>
              Continue with your Google account. New users get an account created
              automatically — no password to manage.
            </p>

            {/* Google Sign In */}
            <button
              onClick={handleGoogleAuth}
              disabled={loading}
              className="action-btn large"
              style={{ width: '100%', marginTop: '16px' }}
            >
              {loading ? 'Please wait…' : 'Continue with Google'}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
